import { type QuestionnaireItem } from "fhir/r3"
import { useContext } from "react"
import { QuestionnaireContext } from "../../context/QuestionnaireContext"
import { questionClass } from "./questionClass"

export function DisplayQuestion({
  topLevel,
  question,
}: {
  topLevel: boolean
  question: QuestionnaireItem
}): JSX.Element {
  // Questionnaire Context
  const questionnaireContext = useContext(QuestionnaireContext)
  if (!questionnaireContext) {
    throw new Error("DisplayQuestion must be used within a QuestionnaireProvider")
  }
  const { responses } = questionnaireContext

  if (topLevel) {
    return (
      <div className={questionClass(question, responses)}>
        <h1>{question.text}</h1>
        <h4>{question.definition}</h4>
      </div>
    )
  }
  return <p>{question.text}</p>
}
